import { render, staticRenderFns } from "./DatatableTypologyServices.vue?vue&type=template&id=0f23a229&scoped=true"
import script from "./DatatableTypologyServices.vue?vue&type=script&lang=js"
export * from "./DatatableTypologyServices.vue?vue&type=script&lang=js"
import style0 from "./DatatableTypologyServices.vue?vue&type=style&index=0&id=0f23a229&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f23a229",
  null
  
)

export default component.exports